<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>My Cloud Booth</BreadcrumbItem>
          <BreadcrumbItem to="/exhibitionEn/index/proGroup/productlist">Product Display</BreadcrumbItem>
          <BreadcrumbItem>{{query.name}}</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
      </div>
      <div class="f-tar" style="padding-top: 37px;">
        <Button @click="$router.push('/exhibitionEn/index/proGroup/productlist')">Back</Button>
      </div>
    </div>

    <proGroupProItem />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import proGroupProItem from "../components/product-group-proItem.vue";

export default {
  name: "product-group-proList",
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    query() {
      return this.$router.history.current.query;
    }
  },
  components: {
    proGroupProItem,
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getProductByGroupId: "productModule/getProductByGroupId",
    }),
    async init() {
      let list = await this.getProductByGroupId({
        By: this.query.id,
        PageSize: 1000,
      });
      console.log(11,list);
    },
    linkTo(e) {
      console.log(e);
    }
  }
};
</script>

<style scoped lang="scss">
</style>